<script setup>
  const { small } = defineProps({ small: Boolean, center: Boolean });
</script>

<template>
  <FightTitleDesktop :small="small" :center="center">
    <template v-slot:whiteCorner><slot name="whiteCorner" /></template>
    <template v-slot:blackCorner><slot name="blackCorner" /></template>
  </FightTitleDesktop>
  <FightTitleMobile :small="small" center>
    <template v-slot:whiteCorner><slot name="whiteCorner" /></template>
    <template v-slot:blackCorner><slot name="blackCorner" /></template>
  </FightTitleMobile>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped></style>
